import { render, staticRenderFns } from "./sellerRating.vue?vue&type=template&id=b1e598e0&scoped=true&lang=html&"
import script from "./sellerRating.vue?vue&type=script&lang=js&"
export * from "./sellerRating.vue?vue&type=script&lang=js&"
import style0 from "./sellerRating.vue?vue&type=style&index=0&id=b1e598e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e598e0",
  null
  
)

export default component.exports